export default {
  en: {
    applepay: {
      addline: 'Add a line',
      amount: 'Amount',
      label: 'Label',
      message: {
        payment_title: 'Payment for',
        payment_succeeded: 'Payment successfull'
      },
      removeline: 'Remove',
      title: 'Ask for a paiement',
      title_placeholder: 'Provide a title',
      total: {
        amount: 'Total amount',
        label: 'Total'
      }
    },
    authentication: {
      title: 'Please, login'
    },
    block_modal: {
      confirm: 'Confirm you really wish to block this user?',
      title: 'Block user'
    },
    close_modal: {
      confirm: 'Confirm you really wish to end this discussion?',
      title: 'Close room'
    },
    closed_modal: {
      title: 'Room closed'
    },
    crm: {
      email: 'Email: ',
      phone: 'Phone: ',
      results_for: 'Result(s) for',
      search_users: 'Search for users',
      search_placeholder: 'Type a name or an email',
      title: 'CRM'
    },
    doc_title_new_msg: 'New message',
    login: {
      connect: 'Se connecter',
      email: 'Email address',
      login: 'Sign in',
      password: 'Password',
      password_lost: 'Forgot your password ?',
      welcome: 'Welcome'
    },
    header: {
      home: 'Go to Dashboard',
      break: 'Take a break',
      unbreak: 'Quit break',
      stats: 'Statistics',
      admin: 'Admin',
      settings: 'Settings',
      logout: 'Logout'
    },
    details: {
      visitor: "Customer's infos",
      general: 'General infos',
      name: 'Name',
      language: 'Language',
      device: 'Device',
      browser: 'Browser',
      path: 'Customer path',
      since: 'Active since',
      source: 'Source',
      skill: 'Skill',
      file: 'Customer file',
      info: 'Customer info',
      phone: 'Phone number',
      satisfaction: 'Customer satisfaction',
      note: 'Note',
      content: 'Content',
      validate: 'Validate',
      previous: 'Previous notes',
      history: 'History'
    },
    error: {
      bad_authentication: 'Invalid email or password',
      bad_rich_content: 'Content has erroneous format',
      bad_token: 'Invalid token',
      unable_to_find_user: 'Unable to find user',
      user_password_can_t_be_resetted: 'The user password can\'t be resetted.',
      skill_or_agent_required: 'A skill or an agent is required'
    },
    location_modal: {
      search: 'Search for an address…',
      title: 'Send locations'
    },
    logout_modal: {
      title: 'Do you want to logout?'
    },
    notes: {
      back: 'Back to disscussions',
      form_content_label: 'Content',
      form_subject_label: 'Subject',
      previous: 'Previous notes'
    },
    other_channels: {
      channels_title: 'Other channels',
      zencalls: 'Appel Zen'
    },
    params: {
      agent_email_label: 'Email',
      agent_first_name_label: 'Firstname',
      agent_last_name_label: 'Lastname',
      agent_skills_label: 'Skills',
      agent_kind_label: 'Category',
      agent_last_login_label: 'Last login',
      agent_max_rooms_label: 'Max simultaneous rooms',
      agent_want_notif_label: 'Receive notifications',
      agent_want_daily_report_label: 'Receive daily reports',
      back_to_dashboard: 'Back to discussions',
      choose_skill: 'Choose a skill',
      offline: 'Offline',
      online: 'Online',
      notification_label: 'Notifications',
      skills: 'Skills',
      table_kind_title: 'Category',
      table_last_login_title: 'Last login',
      table_max_rooms_title: 'Max discussions rooms',
      table_online_title: 'Status',
      table_username_title: 'Agent',
      title_agents: 'Agents parameters',
      title_own: 'My parameters'
    },
    password: {
      change_title: 'Change password',
      confirm_new_password: 'Confirm new password',
      reset: 'Reset password',
      reset_title: 'Reset your password',
      type_new_password: 'Type new password'
    },
    room: {
      address: 'Send address',
      auth: 'Ask for authentication',
      ask_authentication: 'Ask for authentication',
      back: 'Back to discussion',
      block: 'Block user',
      close: 'Close discussion',
      crm: 'Search in CRM',
      history: 'History from',
      payment: 'Ask for payment',
      send: 'Send',
      product: 'Send product',
      transfer: 'Transfer discussion',
      new: 'New discussion',
      accept: 'Would you like to take this new discussion ?',
      closed_title: 'Closed',
      late_title: 'Late',
      no: 'No, thanks !',
      list_title: 'Discussions',
      pick_room: 'Please select a discussion',
      pick_your_emoji: 'Select your emoji',
      running_title: 'Running',
      skill: 'Skill',
      type_your_message: 'Type your message…',
      via_transfer: 'via transfer',
      waiting_title: 'Waiting',
      yes: 'My pleasure 😊'
    },
    senditemslist: {
      title: 'Send a products\' list',
      no_product: 'No product available',
      products_list: 'Select and drag products in the right column'
    },
    statistics: {
      agent_count: 'Online agents',
      average_running: 'Average running time',
      average_waiting: 'Average waiting time',
      agent_stats: 'Agent statistics',
      back_to_dashboard: 'Back to discussions',
      choose_skill_or_agent: 'Choose a skill or an agent',
      closed_count: 'Discussions handled',
      download: 'Download',
      handle_rate: 'Handled discussions / Total discussions',
      lastweek: 'Last 7 days',
      my_stats: 'My statistics',
      skills: 'Skills',
      stock_btn_label: 'Stock',
      stream_btn_label: 'Stream',
      title: 'Statistics',
      thismonth: 'This month',
      today: 'Today',
      waiting_count: 'Discussions',
      yesterday: 'Yesterday'
    },
    transfer_modal: {
      select_skill: 'Select to which skill you wish to transfer the discussion',
      skill_estimated_waiting_time: 'Estimated waiting time',
      title: 'Transfer discussion'
    },
    transferred_modal: {
      now_in_waiting_section: 'It is now in the "Waiting" section, visible by agents of the selected skill.',
      title: 'Transfer confirmation',
      transfer_successfull: 'The room has been successfully transferred to the skill:'
    },
    user_stats: {
      conversation_time: 'Conversation duration',
      customer_satisfaction: 'Customer satisfaction',
      taken_discussions: 'Discussions count',
      waiting_time: 'Waiting time'
    },
    zencall: {
      immediate_or_schedule_callback: 'Immediate or scheduled callback',
      select_a_skill_for_callback: 'Select a skill for the callback:',
      thanks_for_choosing_a_skill: 'Please choose a skill',
      title: 'Appel Zen'
    },
    Cancel: 'Cancel',
    Loading: 'Loading',
    OK: 'OK',
    Remove: 'Remove'
  },
  fr: {
    applepay: {
      addline: 'Ajouter une ligne',
      amount: 'Montant',
      label: 'Libellé',
      message: {
        payment_title: 'Paiement pour',
        payment_succeeded: 'Paiement réussi'
      },
      title_placeholder: 'Saisissez un titre',
      removeline: 'Supprimer',
      title: 'Demander un paiement',
      total: {
        amount: 'Montant total',
        label: 'Total'
      }
    },
    authentication: {
      title: 'Connectez-vous'
    },
    block_modal: {
      confirm: 'Souhaitez-vous vraiment bloquer ce visiteur ?',
      title: 'Bloquer ce visiteur'
    },
    close_modal: {
      confirm: 'Souhaitez-vous vraiment fermer cette discussion ?',
      title: 'Fermer cette discussion'
    },
    closed_modal: {
      title: 'Discussion fermée'
    },
    crm: {
      email: 'Email : ',
      phone: 'Téléphone : ',
      results_for: 'Résultat(s) pour',
      search_users: 'Recherche d\'utilisateurs',
      search_placeholder: 'Saisissez un nom ou un email',
      title: 'CRM'
    },
    doc_title_new_msg: 'Nouveau message',
    login: {
      connect: 'Se connecter',
      email: 'Adresse e-mail',
      login: 'Se connecter',
      password: 'Mot de passe',
      password_lost: 'Mot de passe oublié ?',
      welcome: 'Bienvenue'
    },
    header: {
      home: 'Aller au Dashboard',
      break: 'Se mettre en pause',
      unbreak: 'Revenir de pause',
      stats: 'Statistiques',
      admin: 'Admin',
      settings: 'Paramètres',
      logout: 'Déconnexion'
    },
    details: {
      visitor: 'Informations du client',
      general: 'Informations générales',
      name: 'Nom',
      language: 'Langue',
      device: 'Appareil',
      browser: 'Navigateur',
      path: 'Parcours client',
      since: 'Actif depuis',
      source: 'Source',
      skill: 'Compétence',
      file: 'Fiche Client',
      info: 'Info client',
      phone: 'Téléphone',
      satisfaction: 'Satisfaction client',
      note: 'Note',
      content: 'Contenu',
      validate: 'Valider',
      previous: 'Notes antérieures',
      history: 'Historique'
    },
    error: {
      bad_authentication: 'E-mail ou mot de passe incorrect',
      bad_rich_content: 'Format du message erroné',
      bad_token: 'Jeton d\'authentification erroné',
      unable_to_find_user: 'Impossible de trouver l\'utilisateur',
      user_password_can_t_be_resetted: 'Le mot de passe de l\'utilisateur ne peut être réinitialisé.',
      skill_or_agent_required: 'Choisir une compétence ou un agent est requis'
    },
    location_modal: {
      search: 'Rechercher une adresse…',
      title: 'Envoyer une adresse'
    },
    logout_modal: {
      title: 'Souhaitez-vous vous déconnecter ?'
    },
    notes: {
      back: 'Retour aux discussions',
      form_content_label: 'Contenu',
      form_subject_label: 'Objet',
      previous: 'Notes antérieures'
    },
    other_channels: {
      channels_title: 'Autres Canaux',
      zencalls: 'Appel Zen'
    },
    params: {
      agent_email_label: 'Email',
      agent_first_name_label: 'Prénom',
      agent_last_name_label: 'Nom',
      agent_skills_label: 'Compétences',
      agent_kind_label: 'Catégorie',
      agent_last_login_label: 'Dernière connexion',
      agent_max_rooms_label: 'Nombre de discussions simultanées maximales',
      agent_want_notif_label: 'Recevoir des notifications',
      agent_want_daily_report_label: 'Recevoir les rapports quotidiens',
      back_to_dashboard: 'Retour aux discussions',
      choose_skill: 'Choisissez une compétence',
      offline: 'Indisponible',
      online: 'En ligne',
      notification_label: 'Notifications',
      skills: 'Compétences',
      table_kind_title: 'Catégorie',
      table_last_login_title: 'Dernière connexion',
      table_max_rooms_title: 'Nombre de discussions max.',
      table_online_title: 'Statut',
      table_username_title: 'Agent',
      title_agents: 'Paramètres agents',
      title_own: 'Mes paramètres'
    },
    password: {
      change_title: 'Modifier le mot de passe',
      confirm_new_password: 'Confirmer le nouveau mot de passe',
      reset: 'Réinitialiser le mot de passe',
      reset_title: 'Réinitialisez votre mot de passe',
      type_new_password: 'Saisisser le nouveau mot de passe'
    },
    room: {
      address: 'Envoyer une adresse',
      ask_authentication: 'Demander une authentification',
      auth: 'Demander une identification',
      back: 'Retour à la discussion',
      block: 'Bloquer le visiteur',
      close: 'Fermer la discussion',
      crm: 'Recherche CRM',
      history: 'Historique du',
      payment: 'Demander un paiement',
      product: 'Envoyer une fiche produit',
      send: 'Envoyer',
      transfer: 'Transférer la discussion',
      new: 'Nouvelle conversation',
      accept: 'Souhaitez-vous prendre en charge cette nouvelle conversation ?',
      closed_title: 'Fermé',
      late_title: 'En retard',
      list_title: 'Discussions',
      no: 'Non, merci !',
      pick_room: 'Merci de sélectionner une conversation',
      pick_your_emoji: 'Choisissez votre emoji',
      running_title: 'En cours',
      skill: 'Compétence',
      type_your_message: 'Tapez votre message…',
      via_transfer: 'via transfert',
      waiting_title: 'En attente',
      yes: 'Avec plaisir 😊'
    },
    senditemslist: {
      title: 'Envoyer une fiche produit',
      no_product: 'Aucun produit disponible',
      products_list: 'Sélectionnez et faîtes glisser les produits dans la colonne de droite'
    },
    statistics: {
      agent_count: 'Agents en ligne',
      average_running: 'Temps de traitement moyen',
      average_waiting: 'Temps d\'attente moyen',
      agent_stats: 'Statistiques agents',
      back_to_dashboard: 'Retour aux discussions',
      choose_skill_or_agent: 'Choisissez une compétence ou un agent',
      closed_count: 'Discussions traités',
      download: 'Télécharger',
      handle_rate: 'Discussions traitées / Discussions arrivées',
      lastweek: 'Les 7 derniers jours',
      my_stats: 'Mes statistiques',
      skills: 'Compétences',
      stock_btn_label: 'Stock',
      stream_btn_label: 'Flux',
      title: 'Statistiques',
      thismonth: 'Ce mois-ci',
      today: 'Aujourd\'hui',
      waiting_count: 'Discussions',
      yesterday: 'Hier'
    },
    transfer_modal: {
      select_skill: 'Sélectionnez la compétence vers laquelle vous souhaitez transférer la discussion.',
      skill_estimated_waiting_time: 'Temps d\'attente estimé',
      title: 'Transférer la discussion'
    },
    transferred_modal: {
      now_in_waiting_section: 'Celle-ci se trouve désormais dans la section "En attente", visible par les agents de la compétence sélectionnée.',
      title: 'Confirmation du transfert',
      transfer_successfull: 'La discussion a bien été transférée à la compétence :'
    },
    user_stats: {
      conversation_time: 'Temps de conversation',
      customer_satisfaction: 'Satisfaction client',
      taken_discussions: 'Discussions prises',
      waiting_time: 'Temps d\'attente'
    },
    zencall: {
      immediate_or_schedule_callback: 'Rappel immédiat ou planifié',
      select_a_skill_for_callback: 'Sélectionnez une compétence à laquelle le rappel est destiné :',
      thanks_for_choosing_a_skill: 'Merci de choisir une compétence Appel Zen',
      title: 'Appel Zen'
    },
    Cancel: 'Annuler',
    Loading: 'Chargement en cours',
    OK: 'OK',
    Remove: 'Supprimer'
  }
}
